import { Language } from "../types/Language";
export function convertToLanguageCode(lang) {
    switch (lang) {
        case Language.Finnish:
            return "fi";
        case Language.Swedish:
            return "sv";
        default:
            return "";
    }
}
export function convertToLanguage(code) {
    switch (code) {
        case "fi":
            return Language.Finnish;
        case "sv":
            return Language.Swedish;
        default:
            return Language.NULL;
    }
}
